import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import search from "../../images/Search.png";
import MiniDrawer from "../MiniDrawer/MiniDrawer";
import Wrapper from "../UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CryptoJS from "crypto-js";
import showDoc from "../../images/showDoc.svg";
import Forward from "../../images/Group 716.svg";
import { useSearchParams } from "react-router-dom";


const PaymentList = () => {

  const [searchParams] = useSearchParams();

  const encodedId = searchParams.get("id");

  let relocationId = null;

  if (encodedId) {
    try {
      relocationId = atob(encodedId); // 🔓 decode
    } catch (err) {
      console.error("Invalid ID");
    }
  }

  console.log("Decoded Relocation ID:", relocationId);

  const location = useLocation();

  //   const relocationId =
  //     location.state?.relocationId || localStorage.getItem("relocationId");

  const [paymentReceiptResponse, setpaymentReceiptResponse] = useState([]);
  const [loading, setLoading] = useState(false);


  // ✅ ADD MISSING STATES (FIX ERROR)
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const [activeReceiptId, setActiveReceiptId] = useState(null);
  const [paymentData, setPaymentData] = useState([]);
  const [firstItem, setFirstItem] = useState({});

  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;

  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);

  // ✅ SAVE relocationId
  useEffect(() => {
    if (location.state?.relocationId) {
      localStorage.setItem("relocationId", location.state.relocationId);
    }
  }, [location.state]);

  // ✅ FETCH DATA
  useEffect(() => {
    if (!relocationId) return;
    fetchData();
  }, [relocationId]);

  const fetchData = async () => {
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const res = await axios.get(
        `${baseAPI}userget/GetPaymentConfirmationReceipt?is_verified=1&startDate=0&endDate=0&searchParam=${relocationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // ✅ FILTER BY relocationId
      const filteredData = (res.data.data || []).filter(
        (item) => Number(item.relocation_id) === Number(relocationId),
      );

      setpaymentReceiptResponse(filteredData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ SEARCH CLICK FUNCTION
  function toggleSearchDiv(payment_receipt_id) {
    const token = JSON.parse(localStorage.getItem("token"));

    return axios.get(
      `${baseAPI}userget/GetPaymentConfirmation?payment_receipt_id=${payment_receipt_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  // ✅ PAGINATION
  const startIndex = (currentPage - 1) * itemsPerPage;
  const visibleData = paymentReceiptResponse.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  const formatDate = (date) => new Date(date).toLocaleString("en-IN");
  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key,
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  function nextPage1(payment_receipt_id) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(payment_receipt_id, key);
    const url = `/PaymentReceiptInfo?payment_receipt_id=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />

        <div
          className="container-fluid"
          style={{
            padding: "4rem 1rem 1rem 1rem",
            backgroundColor: "#F4F4F4",
            width: "100%",
            overflowX: "auto",
          }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1%",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Payment Confirmation | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>
                    &gt; Accounts & Finance
                  </span>
                  <span style={{ fontSize: "20px" }}>&gt; Sales Register</span>
                  <span style={{ fontSize: "20px" }}>
                    &gt; Payment Confirmation
                  </span>
                </h1>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails wrapperLeadDataReport">
                <div className="">
                  <h2 className="p-2 " style={{ textAlign: "justify" }}>
                    Payment List (Lead ID: {relocationId})
                  </h2>

                  {/* ✅ DETAILS PANEL */}
                  {/* {activeReceiptId && paymentData.length > 0 && (
        <div style={{ background: "#f5f5f5", padding: "10px", marginBottom: "10px" }}>
          <h4>Receipt Details</h4>
          <p><b>Lead ID:</b> {firstItem?.relocation_id}</p>
          <p><b>Amount:</b> {firstItem?.amount}</p>
          <p><b>Status:</b> {firstItem?.Pymt_Status}</p>
        </div>
      )} */}

                  <table>
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Lead ID</th>
                        <th>Upload Date and Time</th>
                        <th>Transaction Type</th>
                        <th>Payment Mode</th>
                        <th>Amount</th>
                        <th>UTR Number</th>
                        <th>Status</th>
                        <th>Remark</th>
                        <th>Sales Coordinator</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8">Loading...</td>
                        </tr>
                      ) : visibleData.length > 0 ? (
                        visibleData.map((item, index) => (
                          <tr key={item.payment_receipt_id}>
                            <td>{startIndex + index + 1}</td>
                            <td>{item.relocation_id}</td>
                            <td>{formatDate(item.created_date)}</td>
                            <td style={{ fontWeight: "bold" }}>
                              {item.transaction_type_name}
                            </td>
                            <td>{item.payment_mode}</td>
                            <td>
                              ₹{" "}
                              {item.UpdatedAmount !== null
                                ? item.UpdatedAmount
                                : item.amount}
                            </td>
                            <td>{item.UTR_Number}</td>
                            <td
                              style={{
                                color:
                                  item.is_verified === 0
                                    ? "#FFA500"
                                    : "#20BF44",
                              }}
                            >
                              {item.is_verified === 0
                                ? "Requested"
                                : "Verified"}
                            </td>
                            <td>{item.remark_Doc}</td>
                            <td>{item.Name}</td>
                            <td style={{ display: "flex", gap: "8px" }}>
                              {/* VIEW DOCUMENT */}
                              <a
                                target="_blank"
                                href={
                                  item.doc_name
                                    ? `${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`
                                    : "#"
                                }
                                rel="noopener noreferrer"
                                style={{
                                  pointerEvents: item.doc_name
                                    ? "auto"
                                    : "none",
                                  opacity: item.doc_name ? 1 : 0.5,
                                }}
                              >
                                📄
                              </a>
                              <img
                                style={{
                                  paddingLeft: "4px",
                                  pointerEvents:
                                    item.is_verified === 0 ? "none" : "auto",
                                  opacity: item.is_verified === 0 ? 0.5 : 1,
                                  cursor:
                                    item.is_verified === 0
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                src={showDoc}
                                alt="showDoc"
                                onClick={() => {
                                  if (item.is_verified !== 0) {
                                    nextPage1(item.payment_receipt_id);
                                  }
                                }}
                              />
                              <img
                                src={Forward}
                                alt="open"
                                style={{
                                  cursor: item.payment_receipt_id ? "pointer" : "not-allowed",
                                  opacity: item.payment_receipt_id ? 1 : 0.5,
                                }}
                                onClick={async () => {
                                  if (!item.payment_receipt_id) return;

                                  try {
                                    const res = await toggleSearchDiv(item.payment_receipt_id);

                                    console.log("Full API 👉", res.data);

                                    const file = res.data.data?.[0]; // safe access

                                    if (file?.uploaded_doc_path) {
                                      window.open(
                                        `${baseImageURL}${file.uploaded_doc_path}`,
                                        "_blank"
                                      );
                                    } else {
                                      alert("Document not available");
                                    }

                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8">No Data</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentList;
